<template>
    <v-container  v-resize="onResize">
        <v-layout row wrap pt-3 pb-4 align-center>
            <v-flex xs12 md6>
                <h1>Divisions for {{ parliamentarian && parliamentarian.DisplayName }}</h1>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex lg1>
                <router-link :to="{ name: 'Parliamentarian', params: { PHID: PHID }}">
                    <Portrait v-bind:PHID="PHID" :fixedHeight="200"></Portrait>
                </router-link>
            </v-flex>
        </v-layout>

        <br/>

        <loader v-if="loading" />
        <template v-if="!loading" >
            <v-menu v-if="this.isMobile" d-inline  :close-on-content-click="true">
                <v-btn outline small slot="activator">
                    Sort <v-icon>sort</v-icon>
                </v-btn>
                <v-list>
                    <v-subheader>
                        Sort by:
                    </v-subheader>
                    <v-list-tile v-for="(item, index) in headers.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                        <v-list-tile-title>
                            {{ item.text }}
                            <v-icon v-if="pagination.sortBy === item.value">{{pagination.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                        </v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>

            <v-layout row wrap align-center>
                <div class="mr-3">
                    <v-text-field :class="{mobileTextField: isMobile}" v-if="!this.loading" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                </div>
                <division-selector class="mr-3" :topics="contexts" :value="selectedContext" @input="selectedContext = $event"></division-selector>
            </v-layout>

            <br/>

            <div class="stats-table">
                <v-data-table
                    :headers="headers" 
                    :items="itemsFiltered"
                    :pagination.sync="pagination"
                    :rows-per-page-items="ROWS_LISTITEMS" 
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    :hide-headers="isMobile"
                    :loading="loading"
                    :search="search"
                    :disable-initial-sort="true">
                    <template v-slot:items="props">
                        <template v-if="isMobile">
                            <router-link class="tr" :to="{ name: 'DivisionIndividual', params: { id: props.item.Id }}">
                                <td>
                                    <div class="flex-content">
                                        <div class="flex-item">
                                            <h3>
                                                {{ props.item.Date | stringDateFormat }}
                                            </h3>
                                        </div>
                                        <div class="flex-item">
                                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Title">
                                                {{ props.item.Title | divisionTitle }}
                                            </div>
                                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Ayes">
                                                {{ props.item.Ayes }}
                                            </div>
                                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Noes">
                                                {{ props.item.Noes }}
                                            </div>
                                            <div class="flex-item flex-item-col flex-item-col-50" data-label="Outcome">
                                                <v-chip v-if="props.item.Outcome === 0" small label color="green">Agreed to</v-chip>
                                                <v-chip v-if="props.item.Outcome === 1" small label color="red">Negatived</v-chip>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </router-link>
                        </template>
                        <template v-if="!isMobile">
                            <router-link class="tr" :to="{ name: 'DivisionIndividual', params: { id: props.item.Id }}">
                                <td class="text-xs-left"><strong>{{ props.item.Date | stringDateFormat }}</strong></td>
                                <td class="text-xs-left">{{ props.item.Title | divisionTitle }}</td>
                                <td class="text-xs-left">{{ props.item.Ayes }}</td>
                                <td class="text-xs-left">{{ props.item.Noes }}</td>
                                <td class="text-xs-left">
                                    <v-chip v-if="props.item.Outcome === 0" small label color="green">Agreed to</v-chip>
                                    <v-chip v-if="props.item.Outcome === 1" small label color="red">Negatived</v-chip>
                                </td>
                            </router-link>
                        </template>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            Your search for "{{ search }}" found no results.
                        </v-alert>
                    </template>
                    <template v-slot:footer>
                    </template>
                </v-data-table>
            </div>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>         
        </template>
    </v-container>
</template>
<script>
import Portrait from '@/components/Portrait.vue'
import Loader from '@/components/Loader.vue';
import DivisionSelector from '../StatisticalInformation/DivisionSelector.vue';
import axios from 'axios';
import moment from 'moment'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['PHID', 'parliament', 'chamber'],
    created() {
        this.initialiseItems();
        this.loadParliamentarian();
    },
    components: {
        Loader,
        Portrait,
        DivisionSelector
    },
    mounted() {
        this.onResize();
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } 
            else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        loadParliamentarian() {
            this.loadingParliamentarian = true;
            const url = `individuals?$orderby=FamilyName,GivenName
            &$filter=PHID%20eq%20%27${this.PHID}%27`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.parliamentarian = response.data.value[0];
                    this.loadingParliamentarian = false;
                    });
        },
        initialiseItems() {
            this.loading = true;
            const floorCrossing = this.divisionType === 'floorCrossing';
            const url = `StatisticalInformation/DivisionsForParliamentarian?phid=${this.PHID}&floorCrossing=${floorCrossing}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => 
                ({ 
                    Date: (new Date(i.Date)).toLocaleDateString(),
                    Title: i.Title,
                    Ayes: i.Ayes,
                    Noes: i.Noes,
                    Outcome: i.Outcome === 0 ? 'Agreed to': 'Negatived'
                }));
            let headers = this.headers.map(h => h.text);
            const filename = `Divisions for ${this.PHID}`;
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        stringDate (value) {
            if (value && value != 'undefined' && value != 'Undefined' 
            && value != '1900-01-01' 
            && value != '1900-01-01T00:00:00Z' 
            && value != '1900-01-1' 
            && value != '0001-01-01'
            && value != '0001-01-01T00:00:00Z') {
                var dateDMY = moment(String(value));
                if (dateDMY.isValid()){
                    return dateDMY.format('DD/MM/YYYY');
                }
                else {
                    var dateFormat =  moment(String(value), 'YYYY-DD-MM');
                    if (dateFormat.isValid()){
                        return dateFormat.format('DD/MM/YYYY');
                    }
                    else {
                        return ''
                    }
                }
            } else {
                return 'present'
            }
        }
    }, 
    filters: {
        divisionTitle: function (value) {
            let splitTitle = value.split(';')
            .slice(0, -1);
            return splitTitle.join(' - ');
        }
    },
    computed: {
            contexts() {
                return [...[...new Set(this.items.map(i => i.Title.split(';')[0]))].sort()]
            },
            selectedChamber() {
                return this.selectedMpOrSenator === 'mp' ? 0 : 1;
            },
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            detailedCsvDownloadIcon() {
                return this.detailedCsvDownloading ? 'cached' : 'text_snippet';
            },
            detailedCsvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.detailedCsvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            itemsFiltered() {
                return this.selectedContext ? this.items.filter(i => i.Title.split(';')[0] === this.selectedContext) : this.items;
            }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        },
        divisionType: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
            isMobile: false,
            ROWS_LISTITEMS: [5, 10, 50, {
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "value": -1
            }],
            title: 'Divisions',
            chartType: 'perYear',
            parliamentarian: null,
            headers: [
                { text: 'Date', value: 'Date' },
                { text: 'Title', value: 'Title' },
                { text: 'Ayes', value: 'Ayes' },
                { text: 'Noes', value: 'Noes' },
                { text: 'Outcome', value: 'Outcome' },
            ],
            items: [],
            selectedMpOrSenator: this.chamber === 0 ? 'mp' : 'senator',
            search: '',
            divisionType: '',
            selectedContext: null,
            loading: true,
            loadingParliamentarian: true,
            csvDownloading: false,
            detailedCsvDownloading: false,
            pagination: {
                rowsPerPage: this.$store.state.ROWS_PER_PAGE
            },
        }
    }
}
</script>
